var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.273,
    height: 20.273,
    viewBox: "0 0 20.273 20.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smiling-emoticon-square-face-with-closed-eyes-svgrepo-com",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7185",
    "data-name": "Path 7185",
    d: "M7.986,7.945H5.372a.615.615,0,1,1,0-1.231H7.986a.615.615,0,1,1,0,1.231Zm7.533-.615a.615.615,0,0,1-.615.615H12.289a.615.615,0,0,1,0-1.231H14.9A.615.615,0,0,1,15.519,7.33Zm-.887,4.965a4.841,4.841,0,0,1-4.483,2.86A4.807,4.807,0,0,1,5.64,12.28a.586.586,0,1,1,1.083-.45,3.638,3.638,0,0,0,3.426,2.151,3.669,3.669,0,0,0,3.406-2.153.587.587,0,0,1,1.077.465Zm2.078,7.979H3.565A3.568,3.568,0,0,1,0,16.71V3.564A3.568,3.568,0,0,1,3.565,0H16.71a3.568,3.568,0,0,1,3.564,3.564V16.709A3.568,3.568,0,0,1,16.71,20.273ZM3.565,1.677A1.889,1.889,0,0,0,1.678,3.564V16.709A1.889,1.889,0,0,0,3.565,18.6H16.71A1.889,1.889,0,0,0,18.6,16.709V3.564A1.889,1.889,0,0,0,16.71,1.677H3.565Z",
    fill: "#39825e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.f6edcf032491e4287883c8f30501985c.svg";
export { ForwardRef as ReactComponent };